// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v0.0.45-1-ga210ca0",
    "hash": "ga210ca0",
    "distance": 1,
    "tag": "v0.0.45",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.0.45",
        "major": 0,
        "minor": 0,
        "patch": 45,
        "prerelease": [],
        "build": [],
        "version": "0.0.45"
    },
    "suffix": "1-ga210ca0",
    "semverString": "0.0.45+1.ga210ca0",
    "version": "0.0.45",
    "date": "2026-03-19T16:53:46.553Z"
};
/* tslint:enable */
